<template>
  <question-template
    name="finalTaxType"
    :info="info"
    :answer1Description="answer1Description"
    :answer2Description="answer2Description"
    :answer1NextPath="answer1NextPath"
    :answer2NextPath="answer2NextPath"
  />
</template>

<script>
export default {
  name: "FinalDecision",

  computed: {
    answer1NextPath: function () {
      const answers = this.$store.getters["questions/getAnswers"];

      if (answers.isIncomeOver) {
        // รายได้มากกว่า 1800000
        if (answers.isRegisteredVat) {
          // ได้จด VAT หรือ ยกเว้นภาษี
          if (answers.goodsType) {
            // ซื้อสิ้นค้ามี VAT
            return "/final_summaries/personal_registered_with_vat";
          } else {
            // ซื้อสิ้นค้าไม่มี VAT
            return "/final_summaries/personal_registered_without_vat";
          }
        } else {
          // ไม่ได้จด VAT หรือ ยกเว้นภาษี
          return "/final_summaries/personal_not_register";
        }
      } else {
        // รายได้ต่ำกว่า
        if (answers.isWantToRegisterVat) {
          // ต้องการจด VAT
          return "/final_summaries/personal_normal_need_register";
        } else {
          // ไม่ต้องการจด VAT
          return "/final_summaries/personal_normal_not_register";
        }
      }
    },
    answer2NextPath: function () {
      const answers = this.$store.getters["questions/getAnswers"];

      if (answers.isIncomeOver) {
        if (answers.isRegisteredVat) {
          if (answers.goodsType) {
            return "/final_summaries/corp_registered_with_vat";
          } else {
            return "/final_summaries/corp_registered_without_vat";
          }
        } else {
          return "/final_summaries/corp_not_register";
        }
      } else {
        if (answers.isWantToRegisterVat) {
          return "/final_summaries/corp_normal_need_register";
        } else {
          return "/final_summaries/corp_normal_not_register";
        }
      }
    },
  },

  data() {
    const { personal, corporation } = this.$store.getters[
      "taxInfo/taxComparationInfo"
    ];
    const personalTax = personal.tax.toLocaleString("th-TH");
    const corporateTax = corporation.tax.toLocaleString("th-TH");

    const answer1Description =
      "(จะเสียภาษีปีนี้ประมาณ " + personalTax + " บาท)";
    const answer2Description =
      "(จะเสียภาษีปีนี้ประมาณ " + corporateTax + " บาท)";
    return {
      answer1Description,
      answer2Description,
      info: {
        title: "ข้อแตกต่างของแต่ละแบบ",
        path: "/info/pros_cons",
      },
    };
  },
};
</script>

<style scoped></style>
